import { render, staticRenderFns } from "./BeneficialOwnerDeclaration.vue?vue&type=template&id=7057f982&"
import script from "./BeneficialOwnerDeclaration.vue?vue&type=script&lang=js&"
export * from "./BeneficialOwnerDeclaration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports